"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySearchSelect = exports.EntitySearchSelectDefaultProps = exports.entitySearchSelectDefaultTransform = exports.SEARCH_QUERY = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var client_1 = require("@apollo/client");
var select_1 = require("../elements/select");
var entity_select_option_1 = require("./entity-select-option");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var entity_select_value_1 = require("./entity-select-value");
var client_2 = require("@apollo/client");
var lodash_1 = require("lodash");
var sprintf_js_1 = require("sprintf-js");
var use_entities_1 = require("../../hooks/use-entities");
var entity_select_multi_value_1 = require("./entity-select-multi-value");
exports.SEARCH_QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query SearchQuery($term: String, $entityTypeNames: [String], $limit: Int, $skip: Int, $orderBy: OrderByInput) {\n    search(term: $term, entityTypeNames: $entityTypeNames, limit: $limit, skip: $skip, orderBy: $orderBy) {\n      meta {\n        count\n        total\n      }\n      results {\n        id\n        name\n        path\n        sitePath\n        slug\n        openGraph {\n          title\n          id\n          description {\n            plain\n            plainTruncated: plain(truncate: { words: 50 })\n          }\n          image {\n            id\n            url\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query SearchQuery($term: String, $entityTypeNames: [String], $limit: Int, $skip: Int, $orderBy: OrderByInput) {\n    search(term: $term, entityTypeNames: $entityTypeNames, limit: $limit, skip: $skip, orderBy: $orderBy) {\n      meta {\n        count\n        total\n      }\n      results {\n        id\n        name\n        path\n        sitePath\n        slug\n        openGraph {\n          title\n          id\n          description {\n            plain\n            plainTruncated: plain(truncate: { words: 50 })\n          }\n          image {\n            id\n            url\n          }\n        }\n      }\n    }\n  }\n"])));
var entitySearchSelectDefaultTransform = function (entity) {
  return {
    value: entity.id,
    label: entity.name,
    entity: entity
  };
};
exports.entitySearchSelectDefaultTransform = entitySearchSelectDefaultTransform;
exports.EntitySearchSelectDefaultProps = {
  pageSize: 50,
  showDescriptions: false,
  placeholder: "Search Platform...",
  transform: exports.entitySearchSelectDefaultTransform,
  entityTypeNames: [],
  loadingMessage: function (_a) {
    var inputValue = _a.inputValue;
    return (0, sprintf_js_1.sprintf)("Fetching results for '%s'...", inputValue);
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(select_1.Select)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var EntitySearchSelect = function (props) {
  var className = props.className,
    entityTypeNames = props.entityTypeNames,
    pageSize = props.pageSize,
    transform = props.transform,
    showDescriptions = props.showDescriptions,
    selectProps = __rest(props, ["className", "entityTypeNames", "pageSize", "transform", "showDescriptions"]);
  var client = (0, client_1.useApolloClient)();
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)("Person");
  var select = defn.select;
  var entities = (0, use_entities_1.useEntities)();
  var searchableEntityTypeNames = (0, lodash_1.keys)((0, lodash_1.pickBy)(entities, function (defn) {
    return defn.includeInSearch;
  }));
  var availableEntityTypeNames = entityTypeNames.length ? (0, lodash_1.intersection)(entityTypeNames, searchableEntityTypeNames) : searchableEntityTypeNames;
  var loadOptions = function (inputValue, prevOptions) {
    return __awaiter(void 0, void 0, void 0, function () {
      var loadOptionsFilter, filter, data, listResults, _a, results, meta, options, allOptions;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            loadOptionsFilter = select.loadOptionsFilter;
            filter = loadOptionsFilter(inputValue);
            return [4 /*yield*/, client.query({
              query: exports.SEARCH_QUERY,
              variables: {
                entityTypeNames: availableEntityTypeNames,
                term: (0, lodash_1.trim)(inputValue),
                limit: pageSize,
                skip: prevOptions.length,
                filter: filter
              }
            })];
          case 1:
            data = _b.sent().data;
            listResults = data.search || {
              results: [],
              meta: {
                count: 0,
                total: 0
              }
            };
            _a = listResults.results, results = _a === void 0 ? [] : _a, meta = listResults.meta;
            options = results.map(transform) || [];
            allOptions = __spreadArray(__spreadArray([], __read(prevOptions || []), false), __read(options), false);
            return [2 /*return*/, {
              hasMore: allOptions.length < meta.total,
              options: options
            }];
        }
      });
    });
  };
  var components = {
    Option: showDescriptions ? entity_select_option_1.EntitySelectOptionWithDescriptions : entity_select_option_1.EntitySelectOption,
    SingleValue: entity_select_value_1.EntitySelectValue,
    MultiValue: entity_select_multi_value_1.EntitySelectMultiValue
  };
  return react_1.default.createElement(My.Container, __assign({}, selectProps, {
    classNamePrefix: "shp--entity-search-select",
    noOptionsMessage: function (obj) {
      return (0, sprintf_js_1.sprintf)("No matches found for '%s'", obj.inputValue);
    },
    loadOptions: loadOptions,
    loadOptionsOnMenuOpen: false,
    className: className,
    components: components,
    padOptions: false
  }));
};
exports.EntitySearchSelect = EntitySearchSelect;
exports.EntitySearchSelect.defaultProps = exports.EntitySearchSelectDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;